import { render, staticRenderFns } from "./DatabaseFooter.vue?vue&type=template&id=808078d0&scoped=true&"
import script from "./DatabaseFooter.vue?vue&type=script&lang=js&"
export * from "./DatabaseFooter.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseFooter.vue?vue&type=style&index=0&id=808078d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808078d0",
  null
  
)

export default component.exports